import { render } from "./UserName.vue?vue&type=template&id=012b1169&ts=true"
import script from "./UserName.vue?vue&type=script&lang=ts"
export * from "./UserName.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__